
import { css } from '@emotion/css';
import { BackendWrap } from 'Shared/backend/BackendWrap';
import { Theme } from 'Shared/backend/Theme';
import { theme, ThemeProvider } from 'Shared/backend/ThemeProvider';
import { PageProvider } from 'Shared/frontend/PageProvider';
import { Show } from 'solid-js';

const linkStyle = () => css(theme().a,{
	display: 'block',
	margin: '0.4em 0'
});


export function DashboardPage(props)
{
	return (
		<ThemeProvider theme={Theme}>
			<PageProvider page={props.page}>
				<BackendWrap>
					<div>
						<div>
							<Show when={props.user.access.includes('venueFullEditor')}>
								<a class={linkStyle()} href='/admin/home'>Homepage</a>
							</Show>

							<Show when={props.user.access.includes('venueEventEditor')}>
								<a class={linkStyle()} href='/admin/events'>Events</a>
							</Show>

							<Show when={props.user.access.includes('venueMenuEditor')}>
								<a class={linkStyle()} href='/admin/menus'>Menu</a>
							</Show>

							<Show when={props.user.access.includes('venueFullEditor')}>
								<a class={linkStyle()} href='/admin/hire'>Venue hire</a>
								<a class={linkStyle()} href='/admin/contact'>Contact</a>
							</Show>

							<Show when={props.user.access.includes('venueDeveloper')}>
								<a class={linkStyle()} href='/admin/settings'>Settings</a>
							</Show>
						</div>

						<br/>
						<br/>

						<a class={css(theme().a)} href='/logout'>Logout</a>
					</div>
				</BackendWrap>
			</PageProvider>
		</ThemeProvider>
	);
}

